const preloadImages = (images) => {
  images.map((item) => loadImage(item));
};

const loadImage = (src) => {
  const img = document.createElement('img');
  img.src = src;
  return src;
};

export default preloadImages;
